import React, { useEffect } from 'react';
import { IGetSubCategoriesShort, IGetSubCategoriesArguments } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getSubCategoriesShortInfoV2 } from 'backend/subcategories';
import FormSelect from 'components/Select/FormSelect';
import style from './ModificationsDishSubCategorySelect.module.scss';

interface IProps {
	setModificationsDishSubCategory: (value: Nullable<string>) => void;
	selectedModificationsDishCategory: Nullable<string>;
}

export const ModificationsDishSubCategorySelect: React.FC<IProps> = React.memo(
	({ setModificationsDishSubCategory, selectedModificationsDishCategory }) => {
		const { response, loading, refetch, responseError } = useFetchData<
			IGetSubCategoriesShort,
			IGetSubCategoriesArguments
		>(selectedModificationsDishCategory ? getSubCategoriesShortInfoV2 : null, {
			categoryId: selectedModificationsDishCategory ? selectedModificationsDishCategory : '',
		});

		useEffect(() => {
			refetch();
		}, [selectedModificationsDishCategory]);

		return (
			<FormSelect
				name="selectedModificationsDishSubCategory"
				label="subcategoryLabel"
				formItemClassName={style.container}
				options={response?.data.subCategories}
				fetchError={responseError}
				loading={loading}
				onRefetch={refetch}
				disabled={!selectedModificationsDishCategory || loading}
				onChange={setModificationsDishSubCategory}
				onMouseDown={(e) => e.stopPropagation()}
				onClick={(e) => e.stopPropagation()}
			/>
		);
	},
);
